
import { URL_PATIENTS_PGSEC, URL_PROYECT, URL_SHOW_PROYECTPGSEC } from 'routes/routes-constants'
import {Details} from '../../common/pgd-pg-common/Details'

type DetailProps = {
  id?: string
}

export const Detail = (props: DetailProps) => {
  return <Details id={props.id} urlPatients={URL_PATIENTS_PGSEC} urlProyects={URL_PROYECT} urlShowProyect={URL_SHOW_PROYECTPGSEC} pgType='pgsec'/>
}